import { IsBoolean, IsIn, IsOptional, IsString, MaxLength } from "class-validator";

import { PostReportReason } from "../post/post.interface";

export const POST_REPORT_REASONS: PostReportReason[] = [
  "spam",
  "harassment",
  "hate",
  "sexual",
  "violence",
  "false_results",
  "other",
];

export class ReportPostDto {
  @IsIn(POST_REPORT_REASONS)
  reason!: PostReportReason;

  @IsOptional()
  @IsString()
  @MaxLength(500)
  note?: string;
}

export class ModerationNoteDto {
  @IsOptional()
  @IsString()
  @MaxLength(1000)
  note?: string;
}

export class ModerationRemoveDto extends ModerationNoteDto {
  @IsIn(POST_REPORT_REASONS)
  reason!: PostReportReason;

  /** Also pause the author's posting for Config…moderation.suspension_days. */
  @IsOptional()
  @IsBoolean()
  suspend_author?: boolean;
}
